export const styles = () => ({
  form: {
    width: '100%',
  },
});
